import React from 'react';
import { IntlProvider } from 'react-intl';

const Context = React.createContext();

class IntlProviderWrapper extends React.Component {
  constructor(...args) {
    super(...args);

    this.switchToEnglish = () => this.setState({ locale: 'en', messages: {} });

    this.switchToCatalan = () => this.setState({ locale: 'ca', messages: {} });

    this.switchToEuskera = () => this.setState({ locale: 'eu', messages: {} });

    this.switchToSpanish = () =>
      this.setState({ locale: 'es', messages: null });

    // pass everything in state to avoid creating object inside render method (like explained in the documentation)
    this.state = {
      locale: 'es',
      messages: null,
      switchToEnglish: this.switchToEnglish,
      switchToCatalan: this.switchToCatalan,
      switchToEuskera: this.switchToEuskera,
      switchToSpanish: this.switchToSpanish,
    };
  }

  render() {
    const { children } = this.props;
    const { locale, messages } = this.state;
    return (
      <Context.Provider value={this.state}>
        <IntlProvider
          key={locale}
          locale={locale}
          messages={messages}
          defaultLocale="es"
        >
          {children}
        </IntlProvider>
      </Context.Provider>
    );
  }
}

export { IntlProviderWrapper, Context as IntlContext };
